export default __webpack_public_path__ + "static/media/README.ef07dc19.md";